import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper';
import Image from 'next/image';

import { MediaQuery, useMediaQuery } from '../../../hooks/useMediaQuery';
import { ProductImage } from '../../../interface/strapi';
import * as S from './styles';

/* eslint-disable-next-line */
type HeroCarouselProps = {
  heroImages: ProductImage[];
  swiperColor: string;
};

export function HeroCarousel(props: HeroCarouselProps) {
  const { heroImages, swiperColor } = props;
  const isMobile = useMediaQuery(MediaQuery.SM);
  const swiperMargin = isMobile ? '0px' : '100px';

  const slides = heroImages?.map((heroImage) => {
    return (
      <SwiperSlide
        className="flex flex-col items-center min-h-full"
        key={heroImage.id}
      >
        <div className="hover:opacity-90">
          <Image
            priority
            alt="carousel image"
            blurDataURL={`/icons/blur-placeholder.png`}
            height={500}
            objectFit="cover"
            placeholder="blur"
            src={heroImage?.attributes.url}
            width={900}
          />
        </div>
      </SwiperSlide>
    );
  });

  return (
    <S.SwiperContainer
      paginationColor={swiperColor}
      shouldDisplayNavigation={!isMobile}
    >
      <Swiper
        autoplay={true}
        className="mySwiper"
        loop={true}
        modules={[Autoplay, Pagination, Navigation]}
        navigation={true}
        pagination={{
          clickable: true
        }}
        speed={900}
        style={{
          marginLeft: swiperMargin,
          marginRight: swiperMargin,
          position: 'unset'
        }}
      >
        {slides}
      </Swiper>
    </S.SwiperContainer>
  );
}

export default HeroCarousel;
